import { type Message, useChat } from '@ai-sdk/react';

import type { AIInputStateControl } from 'src/features/AIInput';

import { getContextFilesMessages } from 'src/sections/@dashboard/ai/shared/utils';
import { Session } from 'src/state';
import { axios } from 'src/utils/axios';

export const useSendAIPromptMessage = (control: AIInputStateControl) => {
  const { messages, setMessages, append, status } = useChat({
    api: `${axios.defaults.baseURL}/ai/chat/conversation/message`,
    headers: {
      authorization: Session.getToken() || '',
      'Content-Type': 'application/json',
    },
    streamProtocol: 'data',
    sendExtraMessageFields: true,
  });

  const {
    selectedContext,
    contextFiles,
    think,
    doSearch: search,
  } = control((s) => ({
    selectedContext: s.selectedContext,
    contextFiles: s.contextFiles,
    think: s.think,
    doSearch: s.doSearch,
  }));

  // //temporary solution to show thinking time will be refactored later with AI conversation
  // // on the future we will need a wrapper to handle the response given back by useChat hook
  // useEffect(() => {
  //   if (!messages.length) return;
  //   const lastMessage: UIMessage & {
  //     think?: boolean;
  //     reasoningTime?: AITiming;
  //     changed?: boolean; //flag control
  //   } = messages[messages.length - 1];
  //   if (!lastMessage || lastMessage?.role === 'user' || lastMessage?.changed)
  //     return;
  //   lastMessage.think = think;
  //   lastMessage.changed = true;
  //   if (lastMessage.think) {
  //     lastMessage.reasoningTime = {
  //       ...aiResponse.reasoningTime,
  //       end: new Date().toISOString(),
  //     };
  //   }
  //   messages.pop();
  //   appendMessage(lastMessage);
  // }, [messages, aiResponse.reasoningTime, think]);

  const appendMessage = (message: Message) => {
    setMessages((state) => [...state, message]);
  };

  const sendMessage = async (message: string) => {
    await append(
      {
        role: 'user',
        content: message,
      },
      {
        body: {
          content: message,
          messagesHistory: messages,
          contextMessage: selectedContext === '/' ? undefined : selectedContext,
          think,
          search,
          contextFiles: getContextFilesMessages(contextFiles),
        },
      },
    );
  };

  return {
    messages,
    appendMessage,
    sendMessage,
    status,
  };
};
